import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import type { NotificationType } from "./useAllNotificationQuery";

export type NotificationHistoryResponse = ResponseType<NotificationType[]>;

function useNotificationHistoryQuery(enabled: boolean) {
  return useQuery<
    AxiosResponseAndError<NotificationHistoryResponse>["response"],
    AxiosResponseAndError<NotificationHistoryResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.notificationHistory],
    queryFn: async () =>
      await ApiRequest.get<NotificationHistoryResponse>(
        `${requestURLs.notification}history`,
      ),
    enabled,
  });
}

export default useNotificationHistoryQuery;
